export const FIREBASE_CONFIG = Object.freeze({
    apiKey: 'AIzaSyBqmwWelNgJNe6QNCpyTbrwqpRf9FRcIlM',
    authDomain: 'my-piano-adventures.firebaseapp.com',
    databaseURL: 'https://my-piano-adventures.firebaseio.com',
    projectId: 'my-piano-adventures',
    storageBucket: 'my-piano-adventuresappspot.com',
    messagingSenderId: '909796213604',
    appId: '1:909796213604:web:6ec78a76c388add7737071'
})